export const CLIENT_TEMPLATE = [
  { Name: "Klient", Value: "0", Category: "templateType" },
  { Name: "Swesum", Value: "1", Category: "templateType" },
  { Name: "Villkor", Value: "2", Category: "templateType" },
  { Name: "Avtal", Value: "3", Category: "templateType" },
  { Name: "Räntefaktura", Value: "4", Category: "templateType" },
];
